module.exports = __webpack_public_path__ + "static/media/wave.6ce47c58.svg";